import { render } from "./SistemSparqon.vue?vue&type=template&id=6565565e&scoped=true"
import script from "./SistemSparqon.vue?vue&type=script&lang=js"
export * from "./SistemSparqon.vue?vue&type=script&lang=js"

import "./SistemSparqon.vue?vue&type=style&index=0&id=6565565e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6565565e"]])

export default __exports__